// The one mapping from the get-product response to the { fields, metafields }
// shape CreateProduct edits. Products and Find a Piece both open the form
// through this: two copies of the mapping is exactly how the scan path once
// dropped `cost` on the floor (CRITICAL-FINDINGS.md, finding 14).
export default function toEditProduct(product) {
    const {
        id, barcode, title, body_html, category, cost, price,
        nwkQuantity, lbQuantity, metafields, vendor, weight, image
    } = product

    return {
        fields: {
            id,
            barcode,
            title,
            body_html: body_html || '',
            category,
            cost,
            price,
            nwk_quantity: nwkQuantity,
            lb_quantity: lbQuantity,
            vendor,
            weight,
            image
        },
        metafields
    }
}
